var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div bb-page>\n<div class=\"page-subheader-var\">\n<h1 translate=\"PUBLIC_BOOKING.RESCHEDULE_REASONS.MOVE_HEADING\"></h1>\n</div>\n<div bb-include=\"basket_item_summary_var\"></div>\n<div>\n<p ng-show=\"bb.moveReasons.length > 0\">\n<span class=\"bb-summary-label3\">\n<span translate=\"PUBLIC_BOOKING.RESCHEDULE_REASONS.MOVE_REASON\"></span>\n</span>\n<select ng-model=\"bb.current_item.move_reason\" id=\"cancel_reason\" class=\"form-control\" ng-options=\"option.id as option.text for option in bb.moveReasons\">\n</select>\n</p>\n</div>\n<div class=\"bb-step-navigation\">\n<div class=\"row\">\n<div class=\"col-sm-offset-8 col-sm-3 col-sm-push-1 text-right\">\n<bb-move-booking booking=\"bb.current_item\" selected-move-reason=\"bb.current_item.move_reason\">\n</bb-move-booking>\n</div>\n</div>\n</div>\n</div>\n";
var id1="public-booking/_templates/steps/reschedule_reasons.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/_templates/steps/reschedule_reasons.html
// module id = 1206
// module chunks = 0